import { createSlice } from "@reduxjs/toolkit";

import {
  getSchedulingNotificationAction,
  getSchedulingNotificationCountAction,
  postSchedulingNotificationClearAction,
} from "@/redux/notification/action";
import { initialState } from "@/redux/notification/initialState";
import type { NotificationType } from "@/redux/notification/notificationTypes";
import { notificationReducer } from "@/redux/notification/reducer";

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: notificationReducer,
  extraReducers: (builder) => {
    builder
      .addCase(
        getSchedulingNotificationAction.pending,
        (state: NotificationType) => ({
          ...state,
          fetching: true,
        })
      )
      .addCase(
        getSchedulingNotificationAction.fulfilled,
        (state: NotificationType, { payload }) => {
          const { result = {}, message, status_code, success, count } = payload;
          if (success === 0) {
            return {
              ...state,
              fetching: false,
              error: message,
              success: 0,
              statusCode: status_code,
            };
          }

          return {
            ...state,
            fetching: false,
            // notificationCount: count,
            scheduleNotificationList: result,
            scheduleNotificationListCount: count,
          };
        }
      )
      .addCase(
        getSchedulingNotificationAction.rejected,
        (state: NotificationType, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(
        getSchedulingNotificationCountAction.pending,
        (state: NotificationType) => ({
          ...state,
          fetching: true,
        })
      )
      .addCase(
        getSchedulingNotificationCountAction.fulfilled,
        (state: NotificationType, { payload }) => {
          const {
            notification_count,
            message,
            status_code,
            success,
            attendence,
          } = payload;
          if (success === 0) {
            return {
              ...state,
              fetching: false,
              error: message,
              success: 0,
              statusCode: status_code,
            };
          }
          return {
            ...state,
            fetching: false,
            // notificationCount: notification_count,
            attendence,
          };
        }
      )
      .addCase(
        getSchedulingNotificationCountAction.rejected,
        (state: NotificationType, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(
        postSchedulingNotificationClearAction.fulfilled,
        (state: NotificationType, { payload }) => {
          const { success, message, status_code } = payload;

          // If API failed
          if (success === 0) {
            return {
              ...state,
              fetching: false,
              error: message,
              success: 0,
              statusCode: status_code,
            };
          }
          state.fetching = false;
          state.success = 1;
          state.statusCode = status_code;
          state.message = message || "";
          state.notificationCount = 0;
          state.scheduleNotificationListCount = 0;
          state.scheduleNotificationList = [];
        }
      )
      .addCase(
        postSchedulingNotificationClearAction.pending,
        (state: NotificationType) => ({
          ...state,
          fetching: true,
        })
      )
      .addCase(
        postSchedulingNotificationClearAction.rejected,
        (state: NotificationType, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      );
  },
});

export const {
  resetNotificationError,
  resetNotificationSuccess,
  resetScheduleNotificationCount,
  resetScheduleNotificationList,
  resetNotificationStatusCode,
  resetScheduleNotificationListCount,
  setNotificationCount,
  resetNotificationCount,
  setAttendence,
} = notificationSlice.actions;
